import { useEffect } from "react";
import { OrgUser } from "../models/OrgUser";
import { CalibrationCertificate } from "../models/CalibrationCertificate";
import { useLazyGetOrgUserByOrganizationIdAndOrgUserId } from "../operations/queries/getOrgUserByOrganizationIdAndOrgUserId";
import EditOrgUserModal from "../components/EditOrgUserModal";
import { OrgUserFileInput } from "../models/globalTypes";
import { ActiveLicence } from "../models/ActiveLicence";
import { useAppContext } from "../hooks/useAppContext";
import { AdminRole } from "../models/AdminRole";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (
    userId: string,
    firstName: string,
    lastName: string,
    adminRoleId: string | null,
    phoneNumber: string,
    licenceId: string | null,
    calibrationCertificate: CalibrationCertificate,
    newOrgUserFiles: OrgUserFileInput[],
    deletedOrgUserFileIds: string[],
  ) => void;
  submitInProgress: boolean;
  submitErrors?: string[];
  orgUser?: OrgUser;
  activeLicences?: ActiveLicence[] | null;
  canAssignAdminRole: boolean;
  adminRoles?: AdminRole[];
}

const EditOrgUserModalContainer = ({
  open,
  onClose,
  onSubmit,
  submitInProgress,
  submitErrors,
  orgUser,
  activeLicences,
  canAssignAdminRole,
  adminRoles,
}: Props) => {
  const { currentOrganization } = useAppContext();

  const {
    getOrgUserByOrganizationIdAndOrgUserId: getOrgUser,
    data: orgUserWithFiles,
    status: getOrgUserStatus,
  } = useLazyGetOrgUserByOrganizationIdAndOrgUserId();

  useEffect(() => {
    if (currentOrganization && orgUser) {
      getOrgUser({ variables: { organizationId: currentOrganization.id, orgUserId: orgUser.id } });
    }
  }, [getOrgUser, currentOrganization, orgUser]);

  return (
    <EditOrgUserModal
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      submitInProgress={submitInProgress}
      orgUser={orgUserWithFiles?.orgUserByOrganizationIdAndOrgUserId}
      submitErrors={submitErrors}
      activeLicences={activeLicences}
      canAssignAdminRole={canAssignAdminRole}
      adminRoles={adminRoles}
    ></EditOrgUserModal>
  );
};

export default EditOrgUserModalContainer;
